import { Component, Prop, Vue } from "vue-property-decorator";
import { store } from "@/main";
import * as types from "@/store/constants/ins_user_info_types";
@Component
class FollowContent extends Vue {
  @Prop()
  private ctx: any;
  private user_name: any =
    store.getters[types.GETTER_CURRENT_INS_USER_INFO].ins_user_info.user_name;

  private divStyle =
    "font-size: 16px;line-height: 24px;color: rgb(140,140,140);padding-bottom:20px";
  private spanStyle =
    "font-size: 16px;line-height: 24px;  color: rgb(79,121,255);padding:0 4px;";

  public render() {
    return (
      <div style={this.divStyle}>
        Your account <span style={this.spanStyle}>@{this.user_name}</span> is
        set to be private. So only your approved followers will increase your
        followers count. We recommend you{" "}
        <span style={this.spanStyle}>set your account public temporarily</span>{" "}
        in order to get followers fast.
      </div>
    );
  }
}

export default FollowContent;
